export default "__VITE_ASSET__BliYGZ5i__"